import moment from "moment";
import { Postrequestcall } from "../../request/Postrequest";
import { FETCH_CLIENT_TIMESHEET_JOBS_V2, SAVE_CLIENT_TIMESHEETS_NEW } from "../../constant/Apipath";

// Constants
const DEFAULT_TIME = "00:00";
const TIMESHEET_STATUS = {
  IN_PROGRESS: 4,
  IN_REVIEW: 1,
  APPROVED: 2,
  REJECTED: 3
};

const getCurrentTime = () => moment().format("HH:mm");

const formatTime = (time) => {
  if (!time || time === DEFAULT_TIME) {
    return getCurrentTime();
  }
  return moment(time, "HH:mm a").format("HH:mm");
};

const createTimesheetJobObject = (item) => {
  const timesheetHours = item?.timesheetHoursList?.[0] || {};
  const clockInTime = formatTime(timesheetHours.clockInTime);
  const clockOutTime = formatTime(timesheetHours.clockOutTime);

  return {
    Id: item?.id,
    Notes: item?.notes || "",
    UDFields: "",
    Deleted: false,
    clockInTime,
    clockOutTime,
    ClientJobId: item?.clientJobId,
    ClientEmployeeId: item?.timesheetEmployeesList?.[0]?.clientEmployeeId || 0,
    ClientJobActivityId: item?.timesheetActivitiesList?.[0]?.clientActivityId || 0,
    clockInLatitude: timesheetHours.clockInLatitude || 0,
    clockOutLatitude: timesheetHours.clockOutLatitude || 0,
    clockInLongitude: timesheetHours.clockInLongitude || 0,
    clockOutLongitude: timesheetHours.clockOutLongitude || 0,
    ActivityUDFields: "",
    Mileage: 0,
    MileageUnit: "km"
  };
};

const getJobsForTimeSheet = async (userId, { clientTimesheetId, workPackageId }, accessToken) => {
  try {
    const fetchJobsPayload = {
      PageNr: 1,
      FullSearch: "",
      UserId: Number(userId),
      IncludeRecordNr: false,
      FetchAllowedRecordsOnly: true,
      SearchList: [{ clientTimesheetId }]
    };

    const res = await Postrequestcall(
      FETCH_CLIENT_TIMESHEET_JOBS_V2,
      fetchJobsPayload,
      accessToken
    );

    if (res?.status === 200) {
      return {
        workPackageId,
        clientTimesheetId,
        data: res?.data?.data || [],
        status: true
      };
    }

    throw new Error(`Failed to fetch timesheet jobs: ${res?.statusText || "Unknown error"}`);
  } catch (error) {
    console.error(
      `[getJobsForTimeSheet] Failed for clientTimesheetId: ${clientTimesheetId}`,
      error
    );
    throw error;
  }
};

const saveTimesheet = async (data, { workPackageId, timesheetId, ClientId }, accessToken) => {
  try {
    if (!data?.data || !Array.isArray(data.data)) {
      throw new Error("Invalid timesheet data structure");
    }

    let date = null;
    const timesheetData = data.data.map((item) => {
      // Set date from first item if not already set
      if (!date && item?.date) {
        date = item.date;
      }
      return createTimesheetJobObject(item);
    });

    const payload = {
      ReturnRecordId: true,
      ReturnRecordError: true,
      SaveList: [
        {
          workPackageId,
          Id: timesheetId,
          DateSubmitted: new Date(),
          Date: date || new Date(),
          TypeId: 3,
          StatusId: TIMESHEET_STATUS.IN_REVIEW,
          ClientId,
          Deleted: false,
          timeSheetJobList: timesheetData
        }
      ]
    };

    const res = await Postrequestcall(SAVE_CLIENT_TIMESHEETS_NEW, payload, accessToken);
    console.log("res", JSON.stringify(res, null, 2));

    if (res?.data?.status) {
      return {
        status: true,
        timesheetId,
        data: res?.data?.data
      };
    }

    throw new Error(`Failed to save timesheet: ${res?.statusText || "Unknown error"}`);
  } catch (error) {
    console.error(`[saveTimesheet] Failed for timesheetId: ${timesheetId}`, error);
    throw error;
  }
};

export const clockOutTimesheet = async (timesheet, userId, ClientId, accessToken) => {
  if (!timesheet || !Array.isArray(timesheet) || timesheet?.length === 0 || !userId || !ClientId) {
    console.warn("[clockOutTimesheet] No timesheet data provided");
    return [];
  }

  try {
    // Fetch jobs for all timesheets
    const timesheetPromises = timesheet.map((item) =>
      getJobsForTimeSheet(userId, item, accessToken).catch((error) => {
        console.error(`Failed to fetch jobs for timesheet: ${item.clientTimesheetId}`, error);
        return {
          error: error.message,
          timesheetId: item.clientTimesheetId,
          status: false
        };
      })
    );

    const allTimesheetData = await Promise.all(timesheetPromises);

    // Filter out failed requests and process successful ones
    const validTimesheetData = allTimesheetData.filter((item) => item.status !== false);

    if (validTimesheetData.length === 0) {
      console.warn("[clockOutTimesheet] No valid timesheet data to process");
      return allTimesheetData; // Return the error results
    }

    // Save all timesheets with clock out times
    const savePromises = validTimesheetData.map((item) =>
      saveTimesheet(
        item,
        {
          workPackageId: item.workPackageId,
          timesheetId: item.clientTimesheetId,
          ClientId
        },
        accessToken
      ).catch((error) => {
        console.error(`Failed to save timesheet: ${item.clientTimesheetId}`, error);
        return {
          error: error.message,
          timesheetId: item.clientTimesheetId,
          status: false
        };
      })
    );

    const results = await Promise.all(savePromises);

    return results;
  } catch (error) {
    console.error("[clockOutTimesheet] Critical error:", error);
    return [{ error: error.message, status: false }];
  }
};
